var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "teaser-list-item" }, [
    _c("div", { staticClass: "teaser" }, [
      _c(
        "div",
        { staticClass: "teaser-image cell" },
        [
          _c("generic-link", { attrs: { href: _vm.path } }, [
            _c(
              "div",
              {
                staticClass:
                  "image-container aspect-ratio-16by9 effect-image-scale",
              },
              [
                _c("div", {
                  staticClass: "image-background",
                  style: { backgroundImage: "url('" + _vm.image + "')" },
                }),
              ]
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "teaser-content cell" },
        [
          _vm.category
            ? _c(
                "div",
                {
                  staticClass:
                    "article-teaser-content-element article-teaser-category",
                },
                [
                  _c("span", { staticClass: "article-category-link" }, [
                    _vm._v(
                      "\n          " + _vm._s(_vm.category) + "\n        "
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("generic-link", { attrs: { href: _vm.path } }, [
            _c("div", { staticClass: "title" }, [
              _c("h3", [_vm._v(_vm._s(_vm.title))]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "description" }, [
            _vm._v("\n        " + _vm._s(_vm.content) + "\n      "),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "date" },
            [
              _c("font-awesome-icon", { attrs: { icon: "clock" } }),
              _vm._v(" "),
              _c("span", { staticClass: "published-date" }, [
                _vm._v("\n          " + _vm._s(_vm.created) + "\n        "),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }